import { useColorScheme } from "@mui/material/styles";

interface VaykenLogoProps {
  height?: number;
  variant?: "light" | "dark" | "auto";
  /** Just the three squares, for tight spots like the collapsed sidebar. */
  markOnly?: boolean;
}

function VaykenLogo({ height = 28, variant = "auto", markOnly = false }: VaykenLogoProps) {
  const { colorScheme } = useColorScheme();
  const resolved =
    variant === "auto"
      ? colorScheme === "dark"
        ? "light"
        : "dark"
      : variant;
  const textColor = resolved === "light" ? "#ffffff" : "#1a1a2e";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={markOnly ? "0 0 40 40" : "0 0 200 40"}
      height={height}
      fill="none"
      aria-label="VAYKEN"
    >
      {/* Three overlapping rounded squares */}
      <rect
        x="2"
        y="8"
        width="24"
        height="24"
        rx="5"
        fill="#abecfa"
      />
      <rect
        x="8"
        y="4"
        width="24"
        height="24"
        rx="5"
        fill="#602df2"
      />
      <rect
        x="14"
        y="10"
        width="24"
        height="24"
        rx="5"
        fill="#70e0b1"
      />

      {/* Wordmark */}
      {!markOnly && (
        <text
          x="48"
          y="28"
          fontFamily='"Inter", sans-serif'
          fontSize="20"
          fontWeight="700"
          fill={textColor}
          letterSpacing="0.08em"
        >
          VAYKEN
        </text>
      )}
    </svg>
  );
}

export default VaykenLogo;
